import clsx, { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/** Merge classes with tailwind-merge with clsx full feature */

const twCustomConfig = extendTailwindMerge({
  classGroups: {
    text: [
      'text-xs',
      'text-s',
      'text-m',
      'text-l',
      'text-xl',
      'text-h6',
      'text-h5',
      'text-h4',
      'text-h3',
      'text-h2',
      'text-h1',
    ],
    font: [
      'font-hairline',
      'font-extralight',
      'font-light',
      'font-regular',
      'font-medium',
      'font-semibold',
      'font-bold',
      'font-extrabold',
      'font-black',
    ],
  },
});

export default function clsxm(...classes: ClassValue[]): string {
  return twCustomConfig(clsx(...classes));
}
